"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Cn = (props) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 30 20", ...props },
    react_1.default.createElement("defs", null,
        react_1.default.createElement("path", { id: "cn_svg__a", fill: "#FF0", d: "M0-1 .588.809-.952-.309H.952L-.588.809z" })),
    react_1.default.createElement("path", { fill: "#EE1C25", d: "M0 0h30v20H0z" }),
    react_1.default.createElement("use", { xlinkHref: "#cn_svg__a", transform: "matrix(3 0 0 3 5 5)" }),
    react_1.default.createElement("use", { xlinkHref: "#cn_svg__a", transform: "rotate(23.036 .093 25.536)" }),
    react_1.default.createElement("use", { xlinkHref: "#cn_svg__a", transform: "rotate(45.87 1.273 16.18)" }),
    react_1.default.createElement("use", { xlinkHref: "#cn_svg__a", transform: "rotate(69.945 .996 12.078)" }),
    react_1.default.createElement("use", { xlinkHref: "#cn_svg__a", transform: "rotate(20.66 -19.689 31.932)" })));
exports.default = Cn;
//# sourceMappingURL=Cn.js.map